import { Alert, Box, Button, LinearProgress, Stack } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import splineLogo from "./images/spline_color_knockout_logo.png";

function getLoginErrorMessage(error) {
  if (!error) return null;
  const description = error.error_description ?? error.message ?? "";
  if (description.toLowerCase().includes("blocked")) {
    return "Your account has been blocked. Please contact your administrator.";
  }
  return `There was a problem signing you in: ${description}`;
}

function Login({ isLoading }) {
  const { loginWithRedirect, error } = useAuth0();
  const errorMessage = getLoginErrorMessage(error);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ width: "100%", height: "100vh" }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={5}
        sx={{ width: "400px" }}
      >
        <Box component={"img"} src={splineLogo} sx={{ width: "90%" }} />
        {errorMessage && !isLoading && (
          <Alert severity="error" sx={{ width: "100%" }}>{errorMessage}</Alert>
        )}
        {isLoading ? (
          <LinearProgress color="navy" sx={{ width: "100%" }} />
        ) : (
          <Button
            type="submit"
            variant="contained"
            color="navy"
            onClick={() => loginWithRedirect()}
          >
            Login
          </Button>
        )}
      </Stack>
    </Box>
  );
}

export default Login;
